
import { Options, Vue, prop } from "vue-class-component";
import { MonthPickerInput } from "vue-month-picker";
import { mdiCalendarMonth } from "@mdi/js";
import type { MonthIndex } from "@/typing";
import SvgIcon from "@jamescoyle/vue-icon";

class Props {
  lang = prop<string>({ default: "es" });
  months = prop<string[]>({ default: () => [] });
  defaultMonth = prop<number>({});
  defaultYear = prop<number>({});
  modelValue = prop<MonthChangeEvent | undefined>({});
  inputPreFilled = prop<boolean>({ default: true });
}

@Options({
  components: { MonthPickerInput, SvgIcon },
  name: "MonthPickerWrapper",
  watch: {
    modelValue: {
      deep: true,
      handler() {
        this.pickerRemountTrigger = !this.pickerRemountTrigger;
      },
    },
    pickerRemountTrigger() {
      this.$nextTick(() => this.init());
    },
  },
})
export default class MonthPicker extends Vue.with(Props) {
  showSelector = false;
  icon = mdiCalendarMonth;
  pickerRemountTrigger = false;

  /**
   * Add class to child monthpicker component input on mounted.
   *
   * @remarks
   *
   * This is required to use bulma css style.
   */
  public mounted(): void {
    this.init();
  }

  public init(): void {
    const input: HTMLInputElement = this.$el.querySelector("input");
    input.removeAttribute("class");
    input.classList.add("input");
  }

  get pickerDefaultMonth(): number | undefined {
    if (this.modelValue == undefined) {
      return this.defaultMonth;
    }
    return this.modelValue.monthIndex;
  }
  get pickerDefaultYear(): number | undefined {
    if (this.modelValue == undefined) {
      return this.defaultYear;
    }
    return this.modelValue.year;
  }

  public onMonthPickerInput(event: MonthChangeEvent): void {
    this.$emit("update:modelValue", event);
    this.$emit("input", event);
  }
}

export interface MonthChangeEvent {
  from?: Date;
  month?: string;
  monthIndex: MonthIndex;
  to?: Date;
  year: number;
}

export { MonthIndex };
